import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
    fetch() {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getRelationshipRuleConditionModels {
                        id
                        name,
                        type,
                        external_identifier,
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    fetchWhere(type) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getRelationshipRuleConditionModels (
                        type: ${type},
                    ) {
                        id
                        name,
                        type,
                        external_identifier,
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    update(id, data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        data.chosen_instances = data.chosen_instances ? data.chosen_instances : []
        return axios.post('', {
            query: `
                mutation {
                    updateRelationshipRuleConditionModel (
                        id: ${id},
                        name: "${data.name}",
                        external_identifier: "${data.external_identifier}",
                        type: ${data.type}
                    ) {
                        id
                        name,
                        type,
                        external_identifier,
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    create(data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        data.chosen_instances = data.chosen_instances ? data.chosen_instances : []
        return axios.post('', {
            query: `
                mutation {
                    createRelationshipRuleConditionModel (
                        name: "${data.name}",
                        external_identifier: "${data.external_identifier}",
                        type: ${data.type}
                    ) {
                        id
                        name,
                        type,
                        external_identifier,
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    delete(id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    deleteRelationshipRuleConditionModel (
                        id: ${id}
                    )
                }
            `
        })
    }
}